// extracted by mini-css-extract-plugin
module.exports = {"miniTile":"EnergyTrackerReportPage_miniTile__1kPsd","title":"EnergyTrackerReportPage_title__3ppiU","twoColumns":"EnergyTrackerReportPage_twoColumns__3UMGa"};